module.exports = __webpack_public_path__ + "media/mypage/images/icons/icon_bookmark-4cfd0471c89ce3cb6fad93502e035cce.png";